<template>
  <div class="alarm-wrap" ref="alarmRap">
    <div class="chart-wrap">
      <alarm-chart
        :alarmWrap_h="alarmWrap_h"
        :levelData="eventLevel"
        :typeData="actionData"
      ></alarm-chart>
    </div>
    <div class="wrap-content">
      <div class="bg-box search">
        <el-row class="search-items">
          <label class="search-zt zt"> 告警来源： </label>
          <div
            class="sourceItem"
            v-for="(item, index) in alarmSourceList"
            :key="index"
          >
            <div>{{ item.label }}</div>
            <div class="itemIcon" @click="clickCloseItem(index)">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <el-link
            @click="clickOpenSelectSourceModel"
            style="margin-left: 15px; height: 20px"
            type="primary"
            :underline="false"
            >选择告警源</el-link
          >
          <el-link
            v-show="alarmSourceList.length > 10"
            @click="clickResetSourceList"
            style="margin-left: 15px; height: 20px"
            type="danger"
            :underline="false"
            >清除所有告警源</el-link
          >
        </el-row>

        <el-row class="search-items">
          <label class="search-zt zt">
            告警类别：
            <el-checkbox
              class="all-checkbox"
              :indeterminate="isIndeterminate"
              v-model="checkAllCode"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
          </label>
          <el-checkbox-group
            v-model="search.code"
            class="groups"
            @change="changeCode"
          >
            <el-checkbox
              v-for="(item, index) in evenData"
              :label="item.id"
              :key="index"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </el-row>
        <el-row class="search-items">
          <label class="search-zt zt">
            告警类型：
            <el-checkbox
              class="all-checkbox"
              :indeterminate="isIndeterminateType"
              v-model="checkAllType"
              @change="handleCheckAllChangeType"
              >全选</el-checkbox
            >
          </label>
          <el-checkbox-group
            v-model="search.type"
            @change="changeType"
            class="groups"
          >
            <el-checkbox
              v-for="(item, index) in actionData"
              :label="item.id"
              :key="index"
              >{{ item.displayName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-row>
        <el-row class="search-items">
          <label class="search-zt zt">
            告警状态：
            <el-checkbox
              class="all-checkbox"
              :indeterminate="isIndeterminateState"
              v-model="checkAllState"
              @change="handleCheckAllChangeState"
              >全选</el-checkbox
            >
          </label>
          <el-checkbox-group
            v-model="search.warnState"
            @change="changeState"
            class="groups"
          >
            <el-checkbox
              v-for="(item, index) in stateData"
              :label="item.id"
              :key="index"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-row>
        <el-row class="search-items">
          <label class="search-zt zt">
            告警等级：
            <el-checkbox
              class="all-checkbox"
              :indeterminate="isIndeterminateGrade"
              v-model="checkAllGrade"
              @change="handleCheckAllChangeGrade"
              >全选</el-checkbox
            >
          </label>
          <el-checkbox-group
            v-model="search.level"
            @change="changeGrade"
            class="groups"
          >
            <el-checkbox
              v-for="(item, index) in eventLevel"
              :label="item.level"
              :key="index"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-row>
        <el-row class="search-items search-time" style="padding-left: 5px">
          <label class="search-zt zt">告警时间：</label>
          <!-- <el-date-picker
            v-model="search.date"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :unlink-panels="true"
            class="date-box"
            size="small"
          ></el-date-picker> -->

          <el-date-picker
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy/MM/dd HH:mm:ss"
            size="small"
            v-model="search.startTime"
            type="datetime"
            placeholder="选择开始时间"
            default-time="00:00:00"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <span
            style="
              color: #000;
              height: 32px;
              line-height: 28px;
              margin: 0px 10px;
              font-size: 28px;
            "
            >-</span
          >
          <el-date-picker
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy/MM/dd HH:mm:ss"
            size="small"
            v-model="search.endTime"
            type="datetime"
            placeholder="选择结束时间"
            align="right"
            :picker-options="pickerOptions"
          >
          </el-date-picker>

          <el-button
            type="primary"
            style="margin-left: 14px"
            class="magin-left-8"
            @click="bindGetElem('')"
            size="small"
            >查询</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 14px"
            class="magin-left-8"
            size="small"
            @click="bindAlarm"
            >批量确认告警</el-button
          >
        </el-row>
      </div>
      <div class="table-content">
        <div class="alarm-list">
          <div class="alarm-header">告警消息列表</div>
          <div class="alarm-body">
            <div
              class="alarm-item"
              v-for="item in tableData"
              :key="item.id"
              @click="alarmSelect(item)"
              :style="{ background: getBg(item) }"
            >
              <div class="alarm-state">
                <span class="title">告警来源</span>
                <span class="source">{{ item.measureName }}</span>
              </div>
              <div class="alarm-info">
                <div class="alarm-info-item">
                  <span class="alarm-label">告警名称</span>
                  <span class="alarm-label-txt">{{ item.displayName }}</span>
                </div>
                <div class="alarm-info-item">
                  <span class="alarm-label">告警级别</span>
                  <span
                    class="alarm-label-txt"
                    :style="{ color: item.levelInfo.color }"
                    >{{
                      item.levelInfo.name == "" ? "-" : item.levelInfo.name
                    }}</span
                  >
                </div>
                <div class="alarm-info-item">
                  <span class="alarm-label">告警状态</span>
                  <span
                    class="alarm-label-txt"
                    style="color: #ff0000"
                    v-if="item.state == 0"
                    >未确认</span
                  >
                  <span
                    class="alarm-label-txt"
                    style="color: #f78282"
                    v-else-if="item.state == 1"
                    >未处理</span
                  >
                  <span class="alarm-label-txt" style="color: #1363f5" v-else
                    >已处理</span
                  >
                </div>
                <template v-if="item.state !== 0">
                  <div class="alarm-info-item">
                    <span class="alarm-label">确认人</span>
                    <span class="alarm-label-txt">{{
                      item.confirmingUserNickname == ""
                        ? "-"
                        : item.confirmingUserNickname
                    }}</span>
                  </div>
                  <div class="alarm-info-item">
                    <span class="alarm-label">确认时间</span>
                    <span class="alarm-label-txt">{{
                      item.confirmingTime == "" ? "-" : item.confirmingTime
                    }}</span>
                  </div>
                </template>
                <template v-if="item.state > 1">
                  <div class="alarm-info-item">
                    <span class="alarm-label">处理人</span>
                    <span class="alarm-label-txt">{{
                      item.handlingUserNickname == ""
                        ? "-"
                        : item.handlingUserNickname
                    }}</span>
                  </div>
                  <div class="alarm-info-item">
                    <span class="alarm-label">处理时间</span>
                    <span class="alarm-label-txt">{{
                      item.handlingTime == "" ? "-" : item.handlingTime
                    }}</span>
                  </div>
                </template>
              </div>
              <div class="alarm-text">内容：{{ item.content }}</div>
              <div class="alarm-time">{{ item.eventTime }}</div>
              <div
                class="alarm-state"
                style="margin-top: 10px"
                v-if="item.state > 1"
              >
                <span class="title">处理内容：</span>
                <span class="source">{{ item.handlingComment }}</span>
              </div>
              <div class="alarm-btn">
                <div>
                  <el-button
                    type="success"
                    @click.stop="bindShowDetails(item)"
                    size="mini"
                    >告警详情</el-button
                  >
                </div>
                <div class="btn">
                  <el-button
                    type="warning"
                    :disabled="item.state == 1 || item.state == 2"
                    @click.stop="bindConfirmEvent(item)"
                    size="mini"
                    >确认告警</el-button
                  >
                </div>
                <div class="btn">
                  <el-button
                    type="primary"
                    :disabled="item.state == 2 || item.state == 0"
                    @click.stop="bindHandleEvent(item)"
                    size="mini"
                    >处理告警</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageIndex ? page.pageIndex : 0"
              :page-sizes="page.pageSizes"
              :page-size="page.size"
              layout="total,  prev, pager, next,sizes"
              :total="page.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="告警详情" :visible.sync="showDetails" width="800px">
      <nk-chart
        v-if="showDetails"
        :data="chartData"
        :timeTitle="timeTitle"
        title="波形分析"
        :unit="unit"
        :showTitle="false"
        :markLine="markLine"
        :grid="{
          left: '10%',
          right: '8%',
          top: '25%'
        }"
        class="dialog"
      ></nk-chart>
    </el-dialog>
    <el-dialog
      title="填写处理信息"
      :visible.sync="handleEventVisible"
      width="500px"
    >
      <el-form label-width="0px">
        <el-form-item>
          <el-input type="textarea" v-model="comment"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEvent">确定</el-button>
          <el-button
            style="margin-right: 15px"
            @click="handleEventVisible = false"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      center
      title="选择告警来源"
      :visible.sync="showAlarmSource"
      width="50%"
    >
      <resize-container :detailWidth="300">
        <div class="view-wrap" slot="left">
          <div
            :class="[
              'view-tree-item',
              index === viewTreeIndex ? 'view-tree-select' : '',
            ]"
            v-for="(item, index) in viewTree"
            :key="index"
            @click="viewTreeClick(item, index)"
          >
            {{ item.displayName }}
          </div>
        </div>
        <div class="tree-wrap">
          <nk-left-tree
            ref="tree"
            :checkbox="true"
            :defaultCurrent="false"
            :data="leftTreeData"
            :defaultExpandedAll="true"
            :checkStrictly="true"
            v-if="leftTreeData.length > 0"
          ></nk-left-tree>
        </div>
      </resize-container>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAlarmSource = false">关 闭</el-button>
        <el-button type="primary" @click="getselectedNode">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { EVEN } from "@/config/data.js";
import api from "@common/api/index.js";
import DateTool from "@/utils/dateTool.js";
import handleData from "@/utils/handleData.js";
import NkTable from "@/components/common/NkTable.vue";
import AlarmChart from "@/components/page/alarm/AlarmChart.vue";
import NkChart from "@/components/common/NkChart.vue";
import { isNull } from "util";
import cookie from "@/utils/cookie";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import NkLeftTree from "@/components/common/NKPopupLeftTree.vue";
import * as utils from "@/utils/index.js";
export default {
  name: "alarm",
  // 引用组件
  components: { NkTable, AlarmChart, NkChart, ResizeContainer, NkLeftTree },
  data() {
    return {
      alarmWrap_h: 0,
      search: {
        code: [],
        type: [],
        warnState: [],
        level: [],
        warnHandleId: "0",
        date: "",
        startTime: "",
        endTime: "",
      },
      evenData: EVEN,
      actionData: [], //告警类型数据
      evenTableData: [], //所有的告警数据
      tableData: [], //告警消息列表数据
      page: {
        //分页数据
        pageSizes: [10, 20, 50, 100], //每页显示条目个数
        size: 10,
        pageIndex: 1,
        total: 0,
      },
      handleEventVisible: false, //告警处理弹窗状态
      eventId: "", //当前选中的告警ID
      alarmList: [], //批量处理告警数量
      comment: "", //告警的处理信息
      showDetails: false, //告警详细信息弹窗状态
      timeTitle: "", //告警详细信息时间范围
      chartData: [], //echarts对象
      unit: "", //单位
      markLine: null,
      stateData: [
        //告警状态数据
        { id: 1, name: "未确认" },
        // { id: 2, name: "已确认" },
        { id: 3, name: "未处理" },
        { id: 4, name: "已处理" },
      ],
      gradeData: [
        //告警级别数据
        { id: 1, name: "一级" },
        { id: 2, name: "二级" },
        { id: 3, name: "三级" },
        { id: 4, name: "四级" },
        { id: 5, name: "五级" },
        { id: 6, name: "六级" },
      ],
      //告警
      isIndeterminate: false,
      checkAllCode: false,
      isIndeterminateType: false,
      checkAllType: false,
      checkAllState: false,
      isIndeterminateState: false,
      checkAllGrade: false,
      isIndeterminateGrade: false,
      eventLevel: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      alarmSourceList: [], //选择的告警来源列表
      showAlarmSource: false, //告警来源弹窗显示隐藏
      viewTree: [], //视图树数据
      viewTreeIndex: -1, //当前选中的视图数据
      isViewTreeData: true, //是否可以进行请求下次的视图树数据
      leftTreeData: {}, //树数据
    };
  },
  // 实例已经创建完成之后被调用。
  created() {
    this.init();
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    vm.$eventBus.$on("alarmGetEvent", (measureId) => {
      vm.bindGetElem(measureId);
    });
    this.$nextTick(() => {});
    this.alarmWrap_h = this.$refs.alarmRap.offsetHeight;
    console.log(this.$refs.alarmRap.offsetHeight);
  },
  // keep-alive组件激活时调用
  activated() {
    let vm = this;
    if (vm.$route.query.measureId) {
      vm.bindGetElem(vm.$route.query.measureId);
    } else {
      vm.bindGetElem();
    }
  },
  methods: {
    async bindGetTreeTabCode() {
      //树加载
      const res = await this.$api.view.getCompanyViewTreesInfo(
        this.$store.state.user.info.companyId
      );
      if (res.success) {
        this.viewTree = res.data;
        this.viewTreeClick(this.viewTree[0], 0);
      }
    },
    async viewTreeClick(item, index) {
      //点击视图时
      if (!this.isViewTreeData) {
        return;
      }
      this.viewTreeIndex = index;
      this.isViewTreeData = false; //避免不断点击，造成疯狂请求
      const result = await this.$api.view.getViewTreeNodes(item.id);
      this.isViewTreeData = true;
      if (!result.success) {
        this.$message.error(result.msg);
        return;
      }
      this.leftTreeData = utils.creatTreeData(result.data, 0);
    },
    /* 弹窗确定事件 */
    getselectedNode() {
      //获取选中的节点
      let vm = this;
      const checkData = vm.$refs.tree.getCheckedNodes();
      if (checkData.length === 0 || checkData == undefined) {
        this.$message.error("请选择节点");
        return;
      }

      if (vm.alarmSourceList.length > 0) {
        let tempIds = this.alarmSourceList.map((item) => item.id);
        checkData.forEach((item) => {
          if (!tempIds.includes(item.id)) {
            vm.alarmSourceList.push(item);
          }
        });
      } else {
        vm.alarmSourceList = checkData;
      }

      this.showAlarmSource = false;
    },
    /* 清除所有的告警源 */
    clickResetSourceList() {
      this.alarmSourceList = [];
    },
    /* 打开选择告警源弹窗 */
    async clickOpenSelectSourceModel() {
      await this.bindGetTreeTabCode(); //请求视图及对应的视图树
      this.showAlarmSource = true;
    },
    /* 移除一个告警源 */
    clickCloseItem(index) {
      this.alarmSourceList.splice(index, 1);
    },

    // 方法定义
    init() {
      //设置日期为今天
      let date = new Date();
      this.search.startTime = DateTool.format(date, "yyyy-MM-dd") + " 00:00:00";
      this.search.endTime = DateTool.format(date, "yyyy-MM-dd") + " 23:59:59";
      // this.search.startTime  =  this.search.startTime.replace(/\//g,"-")
      //  alert(this.search.startTime)

      api.event.getEventTypes().then((res) => {
        this.actionData = res.data;
        api.event
          .getEventNotifyLevelRedefines(this.$store.state.user.currentCompanyId)
          .then((resObj) => {
            this.eventLevel = resObj.data;
            this.bindGetElem("");
          });
      });
    },
    bindGetElem(measureId = "") {
      if (this.alarmSourceList.length > 0) {
        measureId = this.alarmSourceList.map((item) => item.id);
      }
      if (isNull(this.search.startTime)) {
        this.$message({
          message: "请选择开始时间",
          type: "warning",
        });
        return;
      }
      if (isNull(this.search.endTime)) {
        this.$message({
          message: "请选择结束时间",
          type: "warning",
        });
        return;
      }

      // let listStr = measureId.toString();

      this.getEventRecord(measureId); //更新告警列表
    },
    async getEventRecord(measureId) {
      //获取告警列表
      // JSON.stringify([measureId])
      let res = await api.event.getEventRecord(
        this.$store.state.user.currentCompanyId,
        measureId == ""
          ? 0
          : typeof measureId == "string" && measureId.constructor == String
          ? JSON.stringify([measureId])
          : JSON.stringify(measureId),
        JSON.stringify(this.search.code),
        JSON.stringify(this.search.type),
        null,
        null,
        JSON.stringify(this.search.level),
        this.search.startTime,
        this.search.endTime,
        "",
        ""
      );
      if (!res.success) {
        this.$message.error(res.errorStr);
        return;
      }
      let data = [];
      res.data.forEach((obj) => {
        if (
          this.search.warnHandleId == 0 ||
          obj.handlingUserId == this.search.warnHandleId
        ) {
          let codeTitle = this.evenData.find((e) => e.id == obj.code);
          let actionTitle = this.actionData.find((e) => e.id == obj.action);
          let state = 0; //0 未确认、1未处理、2 已处理
          let confirmingState = false;
          let handlingState = false;
          let warnState = 0;
          if (obj.confirmingUserId && obj.confirmingUserId != "0") {
            /* 1代表已经确认未处理   */
            confirmingState = true;
            state = 1;
          }
          if (obj.handlingUserId && obj.handlingUserId != "0") {
            handlingState = true;
            state = 2;
          }
          const eventItem = this.evenData.find((item) => item.id == obj.code);
          obj.isQuantity = false;
          if (eventItem) {
            obj.isQuantity = eventItem.isQuantity;
          }
          obj.handlingState = handlingState;
          obj.state = state;
          obj.confirmingState = confirmingState;
          obj.codeTitle = codeTitle ? codeTitle.label : "";
          obj.actionTitle = actionTitle ? actionTitle.label : "";

          const levelInfo = this.eventLevel.find((c) => c.level == obj.level);
          obj.levelInfo = levelInfo
            ? levelInfo
            : {
                level: obj.level,
                name: obj.level,
                color: "#000",
              };
          data.push(obj);
        }
      });
      this.evenTableData = this.findArray(
        data,
        this.search.warnState,
        this.search.level,
        this.search.warnHandleId
      );
      this.getTableData(1);
    },
    findArray(data, warnState, level, warnHandleId) {
      let arr = [];
      let index = 1;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        let bol = false;
        if (warnState.length > 0) {
          warnState.forEach((item, i) => {
            if (item == "1") {
              if (element.confirmingUserId == "0") {
                bol = true;
              }
            } else if (item == "2") {
              if (element.confirmingUserId != "") {
                bol = true;
              }
            } else if (item == "3") {
              if (element.handlingUserId == "0") {
                bol = true;
              }
            } else if (item == "4") {
              if (
                element.handlingUserId != "" &&
                element.handlingUserId != "0"
              ) {
                bol = true;
              }
            }
          });
        } else {
          bol = true;
        }
        if (bol) {
          element.index = index;
          index++;
          arr.push(element);
        }
      }
      return arr;
    },
    handleCurrentChange(val) {
      this.getTableData(val);
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData(1);
    },
    getTableData(pageIndex) {
      this.page.pageIndex = pageIndex;
      this.page.total = this.evenTableData.length;
      for (let i = 0; i < this.evenTableData.length; i++) {
        let item = this.evenTableData[i];
        switch (item.level) {
          case 1:
            item.level = "一";
            break;
          case 2:
            item.level = "二";
            break;
          case 3:
            item.level = "三";
            break;
          case 4:
            item.level = "四";
            break;
          case 5:
            item.level = "五";
            break;
          case 6:
            item.level = "六";
            break;
        }
      }
      this.tableData = this.evenTableData.slice(
        (pageIndex - 1) * this.page.size,
        pageIndex * this.page.size
      );
    },
    bindConfirmEvent(item) {
      //点击确认告警
      this.$confirm("是否确认您选中的告警?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (Array.isArray(item)) {
            const req = item.map((item) => item.id);
            this.confirmEvent(req);
          } else {
            this.confirmEvent([item.id]);
          }
        })
        .catch(() => {});
    },
    bindHandleEvent(item) {
      //点击处理告警
      if (item.confirmingUserId) {
        //判断告警是否已经确认
        this.eventId = item.id;
        this.comment = "";
        this.handleEventVisible = true;
      } else {
        this.$message({
          message: "该告警需要确认后才能处理！",
          type: "warning",
        });
      }
    },
    async confirmEvent(eventIds) {
      //进行告警确认请求
      let res = await api.event.confirmEvent(JSON.stringify(eventIds));
      if (!res) {
        return;
      }
      this.$message("确认告警成功！");
      this.alarmList = []; //清空告警
      this.getEventRecord(); //更新告警列表
    },
    async handleEvent() {
      if (!this.comment) {
        this.$message.error("处理信息不能为空！");
        return;
      }
      //点击告警处理确定
      let res = await api.event.handleEvent(this.eventId, this.comment);
      if (!res) {
        return;
      }
      this.$message("处理成功！");
      this.handleEventVisible = false;
      this.getEventRecord(); //更新告警列表
    },
    async alarmSelect(item) {
      if (item.state > 0) {
        return;
      }
      //告警多选
      if (item.bg) {
        //如果存在背景色，说明此次操作是进行取消选择
        this.$set(item, "bg", undefined);
        let index = this.alarmList.findIndex((i) => i.id === item.id);
        this.alarmList.splice(index, 1);
      } else {
        if (cookie.getCookie("theme") != "theme-defalt") {
          //暗黑主题
          this.$set(item, "bg", "#001a3d");
        } else {
          this.$set(item, "bg", "#bce5fb");
        }
        this.alarmList.push(item);
        console.log(
          "🚀 ~ file: alarm.vue ~ line 868 ~ alarmSelect ~ this.alarmList",
          this.alarmList
        );
      }
      this.getBg(item);
    },
    async bindAlarm() {
      //批量确认告警
      if (this.alarmList.length === 0) {
        this.$message({
          message: "请选择您要确认的告警！",
          type: "warning",
        });
        return;
      }
      this.bindConfirmEvent(this.alarmList);
    },
    async bindShowDetails(row) {
      //点击显示详细信息
      if (!row.regulationParam) {
        this.$message.warning("当前告警没有告警详情");
        return;
      }
      let regulationParam = JSON.parse(row.regulationParam);
      let eventTime = new Date(row.eventTime);
      let date = new Date();
      let pointCode = regulationParam.pointCode;
      let pointNumber = regulationParam.pointNumber;
      date.setMinutes(date.getMinutes() - 30);
      let startTime, endTime;
      if (eventTime < date) {
        startTime = new Date(row.eventTime);
        endTime = new Date(row.eventTime);
        startTime.setMinutes(startTime.getMinutes() - 30);
        endTime.setMinutes(endTime.getMinutes() + 30);
      } else {
        startTime = new Date(row.eventTime);
        endTime = new Date();
        startTime.setMinutes(startTime.getMinutes() - 30);
      }
      let strStartTime = DateTool.format(startTime, "yyyy-MM-dd hh:mm:ss");
      let strEndTime = DateTool.format(endTime, "yyyy-MM-dd hh:mm:ss");
      let valueAllElem = [
        {
          measureId: row.measureId,
          pointCode: pointCode,
          pointNumber: pointNumber,
        },
      ];
      console.log("strStartTime", strStartTime);
      console.log("strEndTime", strEndTime);
      let res = await api.measuring.getMeasuringValueAll2(
        valueAllElem,
        strStartTime,
        strEndTime,
        0,
        0
      );
      if (!res) {
        return;
      }
      let selectNodes = [{ id: row.measureId, label: row.measureName }];
      let itemCollect = window.baseConfig.collectData.find(
        (obj) => obj.code == pointCode
      );
      if (!itemCollect) {
        return;
      }
      let codes = [
        {
          code: itemCollect.code,
          title: itemCollect.name,
          show: true,
        },
      ];
      let chartData = handleData.matchMeasuringData(
        res.data,
        selectNodes,
        codes
      );
      let markLineData = [];
      if (regulationParam.threshold) {
        markLineData.push({
          yAxis: regulationParam.threshold,
          name: "告警值",
          lineStyle: {
            color: "red",
          },
        });
      }
      if (regulationParam.recover) {
        markLineData.push({
          yAxis: regulationParam.recover,
          name: "恢复值",
          lineStyle: {
            color: "green",
          },
        });
      }
      this.markLine = {
        data: markLineData,
      };
      this.timeTitle = strStartTime + "~" + strEndTime;
      this.chartData = chartData;
      this.showDetails = true;
    },
    handleCheckAllChange(val) {
      //告警类别全选
      this.search.code = [];
      if (val) {
        EVEN.forEach((item) => {
          this.search.code.push(item.id);
        });
        this.isIndeterminate = true;
      } else {
        this.search.code = [];
        this.isIndeterminate = false;
      }
    },
    changeCode(val) {
      //告警类别选择
      let checkedCount = val.length;
      this.checkAllCode = checkedCount === EVEN.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < EVEN.length;
    },
    handleCheckAllChangeType(val) {
      //告警类型全选
      this.search.type = [];
      if (val) {
        this.actionData.forEach((item) => {
          this.search.type.push(item.id);
        });
        this.isIndeterminateType = true;
      } else {
        this.search.type = [];
        this.isIndeterminateType = false;
      }
    },
    changeType(val) {
      //告警类型选择
      let checkedCount = val.length;
      this.checkAllType = checkedCount === this.actionData.length;
      this.isIndeterminateType =
        checkedCount > 0 && checkedCount < this.actionData.length;
    },
    handleCheckAllChangeState(val) {
      //告警状态全选
      this.search.warnState = [];
      if (val) {
        this.stateData.forEach((item) => {
          this.search.warnState.push(item.id);
        });
        this.isIndeterminateState = true;
      } else {
        this.search.warnState = [];
        this.isIndeterminateState = false;
      }
    },
    changeState(val) {
      //告警状态选择
      let checkedCount = val.length;
      this.checkAllState = checkedCount === this.stateData.length;
      this.isIndeterminateState =
        checkedCount > 0 && checkedCount < this.stateData.length;
    },
    handleCheckAllChangeGrade(val) {
      //告警等级
      this.search.level = [];
      if (val) {
        this.gradeData.forEach((item) => {
          this.search.level.push(item.id);
        });
        this.isIndeterminateGrade = true;
      } else {
        this.search.level = [];
        this.isIndeterminateGrade = false;
      }
    },
    changeGrade(val) {
      //告警状态选择
      let checkedCount = val.length;
      this.checkAllGrade = checkedCount === this.gradeData.length;
      this.isIndeterminateGrade =
        checkedCount > 0 && checkedCount < this.gradeData.length;
    },
  },
  computed: {
    getBg() {
      return (item) => {
        return item.bg || "";
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/alarm.scss"; //引入外部样式
.alarm-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .chart-wrap {
    width: 420px;
    height: 100%;
    margin-right: 13px;
    // width: 490px;height: 100%;margin-right: 13px;
  }
  .wrap-content {
    flex: 1;
    display: flex;
    flex-flow: column;
    overflow: hidden;
    .search {
      width: 100%;
      display: flex;
      flex-flow: column;
      padding: 10px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px;
      .search-items {
        display: flex;
        justify-content: left;
        flex-flow: row;
        flex-wrap: wrap;
        margin-bottom: 7px;
        .search-zt {
          color: #2f2f2f;
          font-weight: bold;
          .all-checkbox {
            text-align: center;
            margin: 0 20px;
            color: #969696;
          }
        }
        .groups {
          flex: 1;
          display: inline-grid;
          grid-template-columns: repeat(6, 1fr);
          text-align: left;
          grid-row-gap: 2px;
          display: flex\0; //兼容ie11可删除
          flex-wrap: wrap\0; //兼容ie11可删除
        }
      }
      .search-time {
        align-items: center;
        margin-bottom: 0;
        .date-box {
          width: 320px;
          margin-left: 20px;
        }
      }
      .el-checkbox {
        margin-right: 0;
        color: #969696;
      }
      .sourceItem {
        margin-left: 15px;
        height: 20px;
        line-height: 20px;
        display: flex;
        align-items: center;
        background: #409eff;
        color: #ffffff;
        border-radius: 4px;
        font-size: 12px;
        padding: 5px;
        margin-bottom: 10px;
        box-sizing: border-box;
        cursor: pointer;
        .itemIcon {
          margin-left: 10px;
        }
      }
      .sourceItem:hover {
        background: red;
      }
    }
    .table-content {
      margin-top: 14px;
      width: 100%;
      flex: 1;
      box-sizing: border-box;
      background: #fff;
      border-radius: 4px;
      padding: 10px;
      .alarm-list {
        width: 100%;
        height: 100%;
        position: relative;
        .alarm-header {
          width: 100%;
          height: 44px;
          background: #63a8eb;
          border: 1px solid #63a8eb;
          border-bottom: none;
          box-sizing: border-box;
          border-radius: 4px 4px 0 0;
          font-size: 18px;
          font-weight: bold;
          line-height: 44px;
          text-align: left;
          padding-left: 10px;
        }
        .alarm-body {
          width: 100%;
          position: absolute;
          top: 44px;
          bottom: 40px;
          border: 1px solid #dedee1;
          box-sizing: border-box;
          padding: 0 14px 14px;
          overflow-y: auto;
          border-radius: 0 0 4px 4px;
          border-top: none;
          .alarm-item {
            width: 100%;
            height: auto;
            padding: 15px 88px 15px 15px;
            box-sizing: border-box;
            background: #f1f2f4;
            border-radius: 4px;
            margin-top: 15px;
            position: relative;
            cursor: pointer;
            .alarm-state {
              font-size: 14px;
              font-weight: bold;
              display: flex;
              height: 25px;
              align-items: center;
              .title {
                color: #87888a;
                margin-right: 5px;
              }
              .source {
                width: auto;
                display: inline-block;
                height: 25px;
                border-radius: 4px;
                background: #fff;
                padding: 0 10px;
                box-sizing: border-box;
                line-height: 25px;
                color: #585858;
                margin-right: 25px;
              }
              .state {
                color: #87888a;
                margin-right: 5px;
                .state-txt {
                  width: auto;
                  display: inline-block;
                  height: 25px;
                  border-radius: 4px;
                  background: #fff;
                  padding: 0 10px;
                  box-sizing: border-box;
                  line-height: 25px;
                }
              }
            }
            .alarm-info {
              width: 100%;
              height: auto;
              display: flex;
              align-items: center;
              margin-top: 5px;
              flex-wrap: wrap;
              .alarm-info-item {
                margin-right: 20px;
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                .alarm-label {
                  font-size: 14px;
                  color: #87888a;
                  margin-right: 5px;
                }
                .alarm-label-txt {
                  width: auto;
                  display: inline-block;
                  height: 25px;
                  border-radius: 4px;
                  background: #fff;
                  padding: 0 10px;
                  box-sizing: border-box;
                  line-height: 25px;
                  color: #585858;
                  margin-right: 25px;
                  font-weight: bold;
                }
              }
            }
            .alarm-text {
              color: #87888a;
              text-align: left;
              margin: 0 0 5px 0;
              overflow: hidden;
              white-space: break-spaces;
              letter-spacing: 1.5px;
            }
            .alarm-time {
              color: #87888a;
              text-align: left;
            }
            .alarm-btn {
              width: 98px;
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
              border-radius: 0 4px 4px 0;
              border-left: 1px solid #fff;
              box-sizing: border-box;
              display: flex;
              flex-flow: column;
              justify-content: center;
              padding: 0 5px;
              .btn {
                margin-top: 5px;
              }
            }
          }
        }
        .pagination {
          position: absolute;
          bottom: 3px;
          width: 100%;
          text-align: right;
          padding-top: 5px;
        }
      }
    }
  }
}
.theme-dark {
  .alarm-wrap {
    .wrap-content {
      background: #1e2432;
      .search {
        background: #030a1d;
      }
      .table-content {
        background: #030a1d;
      }
      .alarm-list {
        .alarm-header {
          background: #212b46;
          border-color: #212b46;
        }
        .alarm-body {
          border-color: #353c4f;
        }
      }
    }
  }
  .alarm-wrap .wrap-content .table-content .alarm-list .alarm-body .alarm-item {
    background: #161e33;
  }
  .alarm-wrap
    .wrap-content
    .table-content
    .alarm-list
    .alarm-body
    .alarm-item
    .alarm-state
    .source {
    background: #303749;
  }
  .alarm-wrap
    .wrap-content
    .table-content
    .alarm-list
    .alarm-body
    .alarm-item
    .alarm-info
    .alarm-info-item
    .alarm-label-txt {
    background: #303749;
  }
  .alarm-wrap
    .wrap-content
    .table-content
    .alarm-list
    .alarm-body
    .alarm-item
    .alarm-btn {
    border-color: #0c1428;
  }
  .dialog {
    background: #030a1d;
  }
}
// 选择来源样式
.view-wrap {
  width: 100%;
  height: 100%;

  overflow-y: auto;
  border: 1px solid #dfdfdf;
  padding: 5px;
  box-sizing: border-box;
  .view-tree-item {
    line-height: 28px;
    padding: 0 5px;
    box-sizing: border-box;
    border-bottom: 1px dashed #d5dadd;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    text-align: left;
  }
  .view-tree-select {
    background: #409eff;
    color: #fff;
  }
}
.tree-wrap {
  width: 100%;
  min-height: 100%;
}
::v-deep #right {
  height: auto !important;
}
</style>
